/* eslint-disable @typescript-eslint/no-explicit-any */
import { pageHead } from "@app/framework/meta";
import { CareersPage } from "@modules/careers/pages";
import { trans } from "@mongez/localization";
import { MetaFunction, useLoaderData } from "@remix-run/react";

// export const loader: LoaderFunction = async ({
//   request,
// }: LoaderFunctionArgs) => {
//   const { http, success, catchErrors } = await getLoaderEndpoint(request);

//   try {
//     const { data } = await getCareersDataServices(http);

//     return success(data);
//   } catch (error: any) {
//     return catchErrors(error);
//   }
// };

export default function Careers() {
  const data = useLoaderData();
  return <CareersPage />;
}

export const meta: MetaFunction = ({ data }: any) => {
  return pageHead({
    title: data?.metaData?.title || trans("careersPage.title"),
    description: data?.metaData?.description || trans("careersPage.description"),
  });
};
